import {
  ActionLoggingEventParams,
  ComponentLoggingEventParams,
} from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { IElementLoggingData } from "@faire/web-api--source/indigofair/data/IElementLoggingData";
import { ITileLoggingData } from "@faire/web-api--source/indigofair/data/ITileLoggingData";

export const buildTileLoggingData = (
  componentLoggingData: ComponentLoggingEventParams,
  tileLoggingData: ITileLoggingData | undefined
): ActionLoggingEventParams => {
  return ActionLoggingEventParams.build({
    ...componentLoggingData,
    action_instance_identifier: tileLoggingData?.instance_identifier ?? "",
    action_positions: tileLoggingData?.tile_position?.toString(),
  });
};

// elements should use their individual logging data which consists of just their instance_identifier
// see https://faire-wholesale.slack.com/archives/C050L8KFJE5/p1739458325388789
// TODO(FD-262619): use this function for all elements
export const buildElementLoggingData = (
  tileLoggingData: ActionLoggingEventParams,
  elementLoggingData: IElementLoggingData | undefined
): ActionLoggingEventParams => {
  return ActionLoggingEventParams.build({
    ...tileLoggingData,
    action_instance_identifier:
      elementLoggingData?.instance_identifier ??
      tileLoggingData.action_instance_identifier,
  });
};
